import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import type { EmployeeUserResponse } from '@/api/model'
import { PageLayout } from '@/components/layout/PageLayout'
import { EmployeeDialog } from './components/EmployeeDialog'
import { EmployeesTable } from './table-components/EmployeesTable'
import { PageHeader } from '@/components/layout/PageHeader'
import { EmployeeModulesDialog } from './components/EmployeeModulesDialog'
import { TemplateDownloadButton } from './header-actions-components/TemplateDownloadButton'
import { EmployeesImportButton } from './header-actions-components/EmployeesImportButton'
import { BulkDownloadInviteCodesButton } from './header-actions-components/BulkDownloadInviteCodesButton'
import { CreateEmployeeButton } from './header-actions-components/CreateEmployeeButton'
import { Separator } from '@/components/shadcn/separator'
import { PageHeaderActions } from '@/components/layout/PageHeaderActions'

export default function EmployeesPage() {
  const { t } = useTranslation('employees')
  const [isEmployeeDialogOpen, setIsEmployeeSheetOpen] = useState(false)
  const [employee, setEmployee] = useState<EmployeeUserResponse | null>(null)

  const [isModulesDialogOpen, setIsModulesDialogOpen] = useState(false)
  const [modulesEmployee, setModulesEmployee] = useState<EmployeeUserResponse | null>(null)

  const handleCreate = () => {
    setEmployee(null)
    setIsEmployeeSheetOpen(true)
  }

  const handleEdit = (employee: EmployeeUserResponse) => {
    setEmployee(employee)
    setIsEmployeeSheetOpen(true)
  }

  const handleOpenChange = (open: boolean) => {
    setIsEmployeeSheetOpen(open)
    if (!open) setEmployee(null)
  }

  const handleModules = (employee: EmployeeUserResponse) => {
    setModulesEmployee(employee)
    setIsModulesDialogOpen(true)
  }

  const handleModulesOpenChange = (open: boolean) => {
    setIsModulesDialogOpen(open)
    if (!open) setModulesEmployee(null)
  }

  return (
    <>
      <PageLayout>
        <PageHeader title={t('header.title')} description={t('header.description')}>
          <PageHeaderActions>
            <TemplateDownloadButton />
            <EmployeesImportButton />
            <BulkDownloadInviteCodesButton />
            <Separator orientation="vertical" className="h-8 mx-2" />
            <CreateEmployeeButton onClick={handleCreate} />
          </PageHeaderActions>
        </PageHeader>

        <EmployeesTable onEdit={handleEdit} onModules={handleModules} />
      </PageLayout>

      <EmployeeDialog
        isOpen={isEmployeeDialogOpen}
        onOpenChange={handleOpenChange}
        employee={employee}
      />

      <EmployeeModulesDialog
        employee={modulesEmployee}
        open={isModulesDialogOpen}
        onOpenChange={handleModulesOpenChange}
      />
    </>
  )
}
